(() => {
  'use strict';

  const VERSION = 'inventory-availability-trust-v3';
  const MAIN_PHONE = '972-752-7947';
  const OLD_PHONE_NUMBERS = ['214-308-8029', '214-308-8299'];
  const modal = document.getElementById('cap-availability-modal');
  if (!modal || modal.dataset.availabilityTrustReady === VERSION) return;
  modal.dataset.availabilityTrustReady = VERSION;

  const dialog = modal.querySelector('.cap-availability-modal__dialog');
  const closeButton = modal.querySelector('[data-availability-close]');
  let lastTrigger = null;

  function focusableElements() {
    if (!dialog) return [];
    return Array.from(dialog.querySelectorAll('a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])'))
      .filter((element) => !element.hidden && element.offsetParent !== null);
  }

  function openModal(trigger) {
    lastTrigger = trigger instanceof HTMLElement ? trigger : null;
    modal.hidden = false;
    modal.setAttribute('aria-hidden', 'false');
    document.body.classList.add('cap-availability-modal-open');
    window.requestAnimationFrame(() => closeButton?.focus({ preventScroll: true }));
  }

  function closeModal() {
    if (modal.hidden) return;
    modal.hidden = true;
    modal.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('cap-availability-modal-open');
    lastTrigger?.focus({ preventScroll: true });
  }

  function replacePhoneText(value) {
    return OLD_PHONE_NUMBERS.reduce((text, oldPhone) => text.split(oldPhone).join(MAIN_PHONE), String(value || ''));
  }

  function replacePhoneInTextNodes(root) {
    if (!root) return;
    const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
    let node = walker.nextNode();
    while (node) {
      const nextValue = replacePhoneText(node.nodeValue);
      if (nextValue !== node.nodeValue) node.nodeValue = nextValue;
      node = walker.nextNode();
    }
  }

  function updateSitePhoneReferences() {
    document.querySelectorAll('header, footer, .cap-find-parts__status, .cap-find-parts__request-status').forEach(replacePhoneInTextNodes);
  }

  function observeDynamicFindPartsPhoneReferences() {
    document.querySelectorAll('.cap-find-parts__status, .cap-find-parts__request-status').forEach((element) => {
      if (element.dataset.phoneReferenceObserverReady === 'true') return;
      element.dataset.phoneReferenceObserverReady = 'true';
      replacePhoneInTextNodes(element);
      new MutationObserver(() => replacePhoneInTextNodes(element)).observe(element, {
        childList: true,
        subtree: true,
        characterData: true
      });
    });
  }

  function addFindPartsNotice() {
    const root = document.getElementById('cap-find-parts-app');
    const resultsWrap = root?.querySelector('.cap-find-parts__results-wrap');
    const resultsHead = resultsWrap?.querySelector('.cap-find-parts__results-head');
    if (!resultsWrap || !resultsHead || resultsWrap.querySelector('[data-availability-results-notice]')) return;

    const notice = document.createElement('div');
    notice.className = 'cap-find-parts__availability-notice';
    notice.dataset.availabilityResultsNotice = 'true';
    notice.setAttribute('role', 'note');
    notice.innerHTML = '<strong>Used auto parts inventory changes throughout the day.</strong><span>We confirm availability before charging your card.</span><button type="button" class="cap-availability-info-link" data-availability-info>Learn More</button>';
    resultsWrap.insertBefore(notice, resultsHead);
  }

  function addCartNotice() {
    const cartBlocks = document.querySelector('#main-cart-footer .cart__blocks');
    const cartCtas = cartBlocks?.querySelector('.cart__ctas');
    if (!cartBlocks || !cartCtas || cartBlocks.querySelector('[data-availability-cart-notice]')) return;

    const notice = document.createElement('div');
    notice.className = 'cap-cart-availability-notice';
    notice.dataset.availabilityCartNotice = 'true';
    notice.setAttribute('role', 'note');
    notice.innerHTML = '<strong>No charge until availability is confirmed</strong><p>Your card is authorized when you place your order, but payment is captured only after we confirm the part is available and the order can be fulfilled.</p><button type="button" class="cap-availability-info-link" data-availability-info>Learn how availability works</button>';
    cartBlocks.insertBefore(notice, cartCtas);
  }

  function currentResultsView(root) {
    const stored = root?.dataset.resultsView;
    if (stored === 'cards' || stored === 'table') return stored;
    return root?.querySelector('.cap-find-parts__view-option--cards.is-active') ? 'cards' : 'table';
  }

  function frozenViewIconMarkup(view) {
    if (view === 'table') {
      return '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M4 5.5h16v13H4zM4 10h16M4 14.5h16M9.5 5.5v13M15 5.5v13"/></svg>';
    }
    return '<svg viewBox="0 0 24 24" aria-hidden="true"><rect x="4" y="4.5" width="6.5" height="6.5" rx="1"/><rect x="13.5" y="4.5" width="6.5" height="6.5" rx="1"/><rect x="4" y="14" width="6.5" height="6.5" rx="1"/><rect x="13.5" y="14" width="6.5" height="6.5" rx="1"/></svg>';
  }

  function sourceViewButton(root, view) {
    return root?.querySelector(`.cap-find-parts__view-option[data-results-view="${view}"]`) ||
      root?.querySelector(`.cap-find-parts__view-option--${view}`) || null;
  }

  function syncFrozenFindPartsTrustUi() {
    const root = document.getElementById('cap-find-parts-app');
    const toolbar = document.querySelector('.cap-find-parts__frozen-toolbar');
    if (!root || !toolbar) return;

    const partsMode = root.dataset.mode !== 'vehicle';
    const frozenAvailability = toolbar.querySelector('[data-frozen-availability-notice]');
    if (frozenAvailability) frozenAvailability.hidden = !partsMode;

    const activeView = currentResultsView(root);
    toolbar.querySelectorAll('[data-frozen-results-view]').forEach((button) => {
      const view = button.dataset.frozenResultsView;
      const active = view === activeView;
      const label = view === 'cards' ? 'Card' : 'Table';
      button.classList.toggle('is-active', active);
      button.setAttribute('aria-pressed', String(active));
      button.setAttribute('aria-label', active ? `${label} view selected` : `Switch results to ${label} view`);
      button.title = active ? `${label} view selected` : `Switch to ${label} view`;
    });
  }

  function switchFrozenResultsView(root, view) {
    const sourceButton = sourceViewButton(root, view);
    if (!sourceButton) return;
    sourceButton.click();
    window.requestAnimationFrame(() => {
      syncFrozenFindPartsTrustUi();
      window.dispatchEvent(new Event('resize'));
    });
  }

  function addFrozenFindPartsControls() {
    const root = document.getElementById('cap-find-parts-app');
    const toolbar = document.querySelector('.cap-find-parts__frozen-toolbar');
    const toolbarInner = toolbar?.querySelector('.cap-find-parts__frozen-toolbar-inner');
    if (!root || !toolbar || !toolbarInner) return false;

    if (!toolbar.querySelector('[data-frozen-results-view-switch]')) {
      const viewSwitch = document.createElement('div');
      viewSwitch.className = 'cap-find-parts__frozen-view-switch';
      viewSwitch.dataset.frozenResultsViewSwitch = 'true';
      viewSwitch.setAttribute('role', 'group');
      viewSwitch.setAttribute('aria-label', 'Switch results view');

      ['table', 'cards'].forEach((view) => {
        const button = document.createElement('button');
        const label = view === 'cards' ? 'Cards' : 'Table';
        button.type = 'button';
        button.className = 'cap-find-parts__frozen-view-option';
        button.dataset.frozenResultsView = view;
        button.innerHTML = `${frozenViewIconMarkup(view)}<span>${label}</span>`;
        button.setAttribute('aria-label', `Switch results to ${view === 'cards' ? 'Card' : 'Table'} view`);
        button.title = `Switch to ${view === 'cards' ? 'Card' : 'Table'} view`;
        button.addEventListener('click', () => switchFrozenResultsView(root, view));
        viewSwitch.appendChild(button);
      });

      toolbarInner.appendChild(viewSwitch);
    }

    if (!toolbar.querySelector('[data-frozen-availability-notice]')) {
      const availability = document.createElement('div');
      availability.className = 'cap-find-parts__frozen-availability';
      availability.dataset.frozenAvailabilityNotice = 'true';
      availability.setAttribute('role', 'note');
      availability.innerHTML = '<strong>Used auto parts inventory changes throughout the day.</strong><span>Availability is confirmed before your card is charged.</span><button type="button" class="cap-availability-info-link" data-availability-info>Learn More</button>';
      toolbarInner.insertAdjacentElement('afterend', availability);
    }

    if (root.dataset.availabilityFrozenObserverReady !== VERSION) {
      root.dataset.availabilityFrozenObserverReady = VERSION;
      new MutationObserver(syncFrozenFindPartsTrustUi).observe(root, {
        attributes: true,
        attributeFilter: ['data-mode', 'data-results-view']
      });
    }

    syncFrozenFindPartsTrustUi();
    return true;
  }

  function initializeFrozenFindPartsControls() {
    let attempts = 0;
    const tryInitialize = () => {
      attempts += 1;
      if (addFrozenFindPartsControls() || attempts >= 120) return;
      window.requestAnimationFrame(tryInitialize);
    };
    tryInitialize();
  }

  document.addEventListener('click', (event) => {
    const target = event.target instanceof Element ? event.target : null;
    const trigger = target?.closest('[data-availability-info], a[href="#availability-info"]');
    if (trigger) {
      event.preventDefault();
      openModal(trigger);
      return;
    }

    if (target?.closest('[data-availability-close]') || target === modal) closeModal();
  });

  document.addEventListener('keydown', (event) => {
    if (modal.hidden) return;

    if (event.key === 'Escape') {
      event.preventDefault();
      closeModal();
      return;
    }

    if (event.key !== 'Tab') return;
    const focusable = focusableElements();
    if (!focusable.length) {
      event.preventDefault();
      dialog?.focus();
      return;
    }

    const first = focusable[0];
    const last = focusable[focusable.length - 1];
    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  });

  function initializeTrustEnhancements() {
    addFindPartsNotice();
    addCartNotice();
    updateSitePhoneReferences();
    observeDynamicFindPartsPhoneReferences();
    initializeFrozenFindPartsControls();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeTrustEnhancements, { once: true });
  } else {
    initializeTrustEnhancements();
  }
})();
